import "./OrganisationsCell.css";

import { RoundedMinusSignIcon } from "../../../../../assets";
import { ProjectRollupOrganisation } from "../../../../../models";
import { DataGridCellFormatterData } from "../../../../data";

export interface OrganisationsCellProps {
  projectKey: string;
  organisations: ProjectRollupOrganisation[];
  /** Omitted, the organisations are listed as plain text. Supplied, each removable one gets a control. */
  onRemove?: (projectKey: string, organisationUuid: string) => void;
}

/** The same props, marked as a DataGrid cell value so the grid will carry them to the formatter. */
export type OrganisationsCellData = DataGridCellFormatterData & OrganisationsCellProps;

export const OrganisationsCell = ({ projectKey, organisations, onRemove }: OrganisationsCellProps): JSX.Element => (
  <div className="OrganisationsCell">
    {organisations.map((organisation, index) => (
      <span className="OrganisationsCell_item" key={organisation.organisationUuid}>
        {`${organisation.organisationName} (${organisation.access})`}
        {onRemove && organisation.canRemove && (
          <button
            type="button"
            className="OrganisationsCell_remove"
            aria-label={`Remove ${organisation.organisationName}`}
            title={`Remove ${organisation.organisationName}`}
            onClick={() => onRemove(projectKey, organisation.organisationUuid)}
          >
            <RoundedMinusSignIcon />
          </button>
        )}
        {index < organisations.length - 1 ? "," : ""}
      </span>
    ))}
  </div>
);
